import React, { useEffect, useLayoutEffect, useRef } from "react";
import Flagmans from "../components/Flagmans";
import History from "../components/History";
import Main from "../components/Main";
import Products from "../components/Products";
import SplitterImage from "../components/SplitImage";
import Footer from "../components/Footer";
import BuyBlock from "../components/BuyBlock";
import Navigation from "../components/Navigation";
import koloroviLogo from "../images/koloroviLogo.svg";
import koloroviBlured from "../images/koloroviBlured.png";
import { checkAndSetStats } from "../helpers/helpers";
import SEO from "../components/SEO";

function AirGold() {
    const doesStatsSent = useRef(false);

    useLayoutEffect(() => {
        document.body.style.backgroundColor = "#E9E5E0";
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    useEffect(() => {
        if (!doesStatsSent.current) {
            checkAndSetStats("koloroviPage");
            doesStatsSent.current = true;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className="bg-kolorovi">
            <SEO
                title="Колекція Kolorovi Sapphires"
                description="Kolorovi Sapphires — яскрава колекція прикрас з кольоровими сапфірами від TSATSKY. Унікальні каблучки та сережки з дорогоцінним камінням."
                url="/kolorovi"
                collection={{ name: "Kolorovi Sapphires", description: "Яскрава колекція прикрас з кольоровими сапфірами" }}
            />
            <Navigation showBack backTo="/" variant="light" />
            <div className="kolorovi_main_wrapper lg:bg-center bg-top">
                <Main
                    path="kolorovi"
                    logoImage={koloroviLogo}
                    textColor="text-black"
                    logoClassNames="my-6"
                    logoAlt="Kolorovi Sapphires Logo"
                    buttonClassNames="kolorovi-button"
                    borderStyles="border-kolorovi"
                    defaultImage={koloroviBlured}
                />
            </div>

            <div>
                <History
                    path="kolorovi"
                    containerClassNames="bg-kolorovi text-black"
                    defaultImage={koloroviBlured}
                />
                <SplitterImage borderStyles="border-kolorovi shadow-bottom" />

                <Flagmans containerClassNames="text-black" />
                <Products
                    path="kolorovi"
                    containerClassNames="text-black bg-kolorovi"
                    productTextStyles={`text-black`}
                    productArticleStyles={`text-black`}
                    buttonStyles="background-kolorovi"
                    defaultImage={koloroviBlured}
                />

                <BuyBlock
                    buttonClassNames={"background-kolorovi"}
                    containerClassNames="text-black bg-kolorovi"
                />
                <Footer containerClassNames={"background-kolorovi"} />
            </div>
        </div>
    );
}

export default AirGold;
